import { SkeletonWave } from "app/components/Skeleton";
import React from "react";



const Loading: React.FC = () => {
  return (
    <div className="w-full min-w-0 h-full flex flex-row gap-[16px] overflow-x-auto">
      {Array.from({ length: 7 }).map((_, index) => {
        return (
          <div key={index} className="w-[255px] " >
            <div className=" flex flex-col space-y-[16px]  ">
              <div className="">
                <SkeletonWave className="h-[40px] w-full bg-gray-10 rounded-md  " />
              </div>
               <div className="flex flex-col space-y-[16px] ">
              {Array.from({ length: 7 }).map((_, i) => (
                <SkeletonWave
                  key={i}
                  className="h-[140px] w-full bg-gray-10 rounded-md "
                />
              ))}
            </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Loading;
